import React from 'react';
import type { ButtonProps, VariantStyles } from './type';
import { lightmodecolors } from '../../../styles/colors';
import { DpValues } from '../../../styles/Dp'; // Replace with your icon library
import { AppStyles } from '../../../styles/AppStyles';

const variantStyles: VariantStyles = {
  primary: {
    backgroundColor: lightmodecolors.Primary2,
    textColor: lightmodecolors.White,
    hoverBackgroundColor: lightmodecolors.Primary3,
    disabledBackgroundColor: lightmodecolors.Grey3,
    disabledTextColor: lightmodecolors.Text7
  },
  secondary: {
    backgroundColor: lightmodecolors.Grey2,
    textColor: lightmodecolors.Text3,
    hoverBackgroundColor: lightmodecolors.Secondary1,
    disabledBackgroundColor: lightmodecolors.Grey3,
    disabledTextColor: lightmodecolors.White
  },
  tertiary: {
    backgroundColor: lightmodecolors.White,
    textColor: lightmodecolors.Text3,
    hoverBackgroundColor: lightmodecolors.Secondary1,
    disabledBackgroundColor: lightmodecolors.White,
    disabledTextColor: lightmodecolors.Text7
  },
  destructive: {
    backgroundColor: 'transparent',
    textColor: lightmodecolors.Negative,
    hoverBackgroundColor: lightmodecolors.Negative20,
    disabledBackgroundColor: lightmodecolors.Grey3,
    disabledTextColor: lightmodecolors.White
  }
};
const Button: React.FC<ButtonProps> = ({
  text,
  textColor,
  size,
  leadingIcon: LeadingIcon,
  trailingIcon: TrailingIcon,
  cornerRadius,
  enabled,
  loading,
  clickable,
  onClick,
  variant
}) => {
  const handleClick = () => {
    if (clickable && enabled && !loading && onClick) {
      onClick();
    }
  };

  const styles = variantStyles[variant];
  return (
    <button
      style={{
        ...(size === 'small'
          ? { ...AppStyles.ButtonSmall }
          : size === 'medium'
            ? { ...AppStyles.ButtonMedium }
            : { ...AppStyles.ButtonLarge }),
        backgroundColor: enabled ? styles.backgroundColor : styles.disabledBackgroundColor || 'gray',
        color: textColor || styles.textColor,
        borderRadius: cornerRadius,
        border:
          variant === 'destructive'
            ? `1px solid ${lightmodecolors.Negative}`
            : variant === 'tertiary'
              ? `1px solid ${lightmodecolors.Grey2}`
              : 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: size === 'small' ? DpValues.DP10 : size === 'medium' ? DpValues.DP12 : DpValues.DP20,
        padding: `${DpValues.DP04} ${DpValues.DP05}`
      }}
      className={`w-full  ${enabled && clickable ? 'cursor-pointer' : 'cursor-not-allowed'} ${
        enabled && clickable ? `hover:bg-${styles.backgroundColor}-dark` : ''
      }`}
      onClick={handleClick}
      disabled={!enabled || loading || !clickable}>
      {typeof LeadingIcon === 'string' ? (
        <img src={LeadingIcon} alt="Leading Icon" style={{ marginRight: '12px', height: '16px', width: '16px' }} />
      ) : (
        LeadingIcon && <LeadingIcon size={20} color="white" />
      )}
      {text}

      {typeof TrailingIcon === 'string' ? (
        <img src={TrailingIcon} alt="Leading Icon" style={{ marginLeft: '8px', height: '16px', width: '16px' }} />
      ) : (
        TrailingIcon && <TrailingIcon size={20} color="white" />
      )}
    </button>
  );
};

export default Button;
